import axiosInstance from "./axiosConfig";

export const getCompanyPrefix = () => {
    var config = {
        method: 'get',
        url: `/admin/view-company`,
    };

    const res = axiosInstance(config)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log("error while getting company prefix: ", error);
            alert("error while getting Company prefix data")
            return null;
        });

    return res;
}

export const deleteCompanyPrefix = (id) => {
    let config = {
        method: 'delete',
        url: `/admin/delete-company/${id}/`,
    };

    const res = axiosInstance.request(config)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log("error in delete company prefix: ", error);
            return null;
        });

    return res;
}

export const addCompanyPrefix = (data) => {
    let apiData = JSON.stringify({ "company_name": data.name, "gs1_company_prefix": data.prefix });

    let config = {
        method: 'post',
        url: `/admin/add-company`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: apiData
    };

    const res = axiosInstance(config)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("error in add prefix: ", err);
            alert("something went wrong, please try later");
            return null;
        });

    return res;
}

export const updateCompanyPrefix = (data, id) => {
    let configData = JSON.stringify({
        "company_name": data.name,
        "gs1_company_prefix": data.prefix
    });

    let config = {
        method: 'put',
        url: `/admin/update-company/${id}/`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: configData
    };

    const res = axiosInstance.request(config)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log("error in update prefix: ", error);
            return null;
        });
    return res;
}